import React from "react";
import user from "src/assets/user.png";
import settings from "src/assets/settings.png";
import help from "src/assets/question.png";
import logout from "src/assets/log-out.png";
import closebutton from "src/assets/close-button.png";
import profileimg from "src/assets/profile.jpg";
import "src/index.css";
import { useNavigate } from "react-router";
import i18n from "src/components/util/languageResource";
import { useState, useEffect, useRef } from "react";
import { MenuItem, Select } from "@mui/material";
import UseUserProfileMenu from "./useUserProfileMenu";
import { LOGOUT } from "src/components/helper/constants";
import { logout as logoutAction, selectAuth } from "src/store/authSlice";
import { useDispatch, useSelector } from "react-redux";

interface DropdownItemProps {
  img: string;
  text: string;
  onClick?: () => void;
}

const BranchProfileMenu = () => {
  const {} = UseUserProfileMenu();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [UserAvaterImagePath] = useState(userInfo.user?.ProfileImagePath);
  const auth = useSelector(selectAuth);
  const handlelogout = () => {
    dispatch(logoutAction());
    LOGOUT();
    navigate("/admin");
  };

  const [open, setOpen] = useState(false);
  let menuRef = useRef<HTMLDivElement>(null);

  const handleBranchProfileClick = () => {
    navigate("/Profile");
  };

  const languageOptions = [
    { value: "en", label: "English" },
    // { value: "hn", label: "हिंदी" },
    // { value: "mr", label: "मराठी" },
    // Add more languages as needed
  ];

  const changeLanguage = (selectedLanguage: string) => {
    i18n.changeLanguage(selectedLanguage);
    localStorage.setItem("selectedLanguage", selectedLanguage); // Store selected language in local storage
  };

  useEffect(() => {
    let handler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  useEffect(() => {
    // Check if a language is stored in local storage, if so, initialize i18n with that language
    const storedLanguage = localStorage.getItem("selectedLanguage");
    if (storedLanguage && i18n.language !== storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);

  return (
    <div className="profilemenu">
      <div className="profilemenu-container" ref={menuRef}>
        <div className="profilemenu-trigger" onClick={() => setOpen(!open)}>
          <img
            src={
              UserAvaterImagePath != process.env.REACT_APP_API_URL
                ? UserAvaterImagePath
                : "/defaultProfile.jpg"
            }
          />
        </div>

        <div
          className={`profilemenu-dropdown-menu ${
            open ? "active" : "inactive"
          }`}
          style={{
            border: "1px solid #ffffff",
          }}
        >
          <div
            style={{
              padding: "20px",
            }}
          >
            <div className="closebutton">
              <a href="#">
                <img
                  src={closebutton}
                  alt="Close Button"
                  onClick={() => setOpen(!open)}
                />
              </a>
            </div>
            <div className="profileouter">
              <div className="profileimg">
                <img
                  src={
                    UserAvaterImagePath != process.env.REACT_APP_API_URL
                      ? UserAvaterImagePath
                      : "/defaultProfile.jpg"
                  }
                />
              </div>
            </div>
            <div className="branchprofilename">
              <h3 style={{ color: "#000000" }}>{auth.user?.PersonName}</h3>
              {/* <p style={{ color: "#a5a5a5" }}>
                <span>{auth.user?.UserRole}</span>
              </p> */}
              <h6 style={{ color: "#000000" }}>
                {" "}
                Employee ID :{" "}
                <span style={{ color: "#000000" }}>
                  {auth.user?.EmployeeID}
                </span>
              </h6>

              <h6 style={{ color: "#000000" }}>
                <span style={{ color: "#000000" }}>
                  {auth.user?.Department}
                </span>
              </h6>
              <p style={{ color: "#a5a5a5" }}>
                <span style={{ color: "#000000" }}>
                  {auth.user?.Designation}
                </span>
              </p>
            </div>

            {/* <div className="languagebox">
              <div>
                <h6>{"Select Language"}</h6>
              </div>
              <div>
                <Select
                  labelId="language-select-label"
                  id="language-select"
                  value={i18n.language}
                  label={"Language"}
                  onChange={(e) => changeLanguage(e.target.value)}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        // Remove padding from the Menu List
                        "& .MuiList-root": {
                          paddingTop: 0,
                          paddingBottom: 0,
                        },
                      },
                    },
                  }}
                  sx={{
                    color: "#A5A5A5",
                    "& fieldset": {
                      border: "none",
                    },
                    "& .MuiSelect-select": {
                      padding: "0px",
                      marginBottom: "10px",
                    },
                    "& .MuiSelect-icon": {
                      marginTop: "-5px",
                      color: "#A5A5A5",
                    },
                  }}
                >
                  {languageOptions.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      sx={{
                        background: "#202328",
                        color: "#A5A5A5",
                        transition: "background 0.3s",
                        "&:hover": {
                          backgroundColor: "#F6FF00 !important",
                          color: "#000",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#F6FF00 !important",
                          color: "#000",
                        },
                        "&.Mui-selected:hover": {
                          backgroundColor: "#F6FF00 !important",
                          color: "#000",
                        },
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div> */}

            <ul className="profilemenu-ul" style={{borderTop:'1px solid #f1f1f1'}}>
              <ProfileDropdownItem
                img={user}
                text={"My Profile"}
                onClick={handleBranchProfileClick}
              />
              <ProfileDropdownItem img={settings} text={"Settings"} />
              <ProfileDropdownItem img={help} text={"Help"} />
              <ProfileDropdownItem
                img={logout}
                text={"Logout"}
                onClick={() => handlelogout()}
              />
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

const ProfileDropdownItem = (props: DropdownItemProps) => {
  const handleBranchProfileClick = () => {
    if (props.onClick) {
      props.onClick(); // Call the onClick handler if it exists
    }
  };
  return (
    <li className="profilemenu-dropdownItem">
      <a href="" onClick={handleBranchProfileClick} className="userprofilemenu">
        <img src={props.img} alt={props.text} />
        {props.text}
      </a>
    </li>
  );
};

export default BranchProfileMenu;
